import React from 'react';


export const BlogTaskSchedular = (props) => {
    return (
        <div className='blog-con'>
            <hr />
            <article>
                <header>
                    <h2>When to Use Job Scheduler</h2>
                </header>

                <section>
                    <p>Job Scheduler is a great tool for automating recurring tasks that need to run periodically or at specific times. Here are some scenarios when you might want to use it:</p>
                    <ul>
                        <li><strong>Automating Data Imports/Exports:</strong> Schedule tasks to import or export data at regular intervals, such as syncing with external systems.</li>
                        <li><strong>Generating Reports:</strong> Schedule tasks to generate reports daily, weekly, or monthly and send them to relevant stakeholders.</li>
                        <li><strong>Periodic Cleanup:</strong> Set up jobs to clean up temporary data or perform maintenance tasks on a recurring schedule.</li>
                        <li><strong>Sending Notifications:</strong> Schedule tasks that send notifications or alerts to users based on specific events or time-based conditions.</li>
                    </ul>
                </section>

                <section>
                    <h2>Using the Job Scheduler in Liferay</h2>
                    <p>Setting up and managing tasks through the Liferay Job Scheduler is straightforward. Here are the key steps:</p>
                    
                    <h3>1. Adding a New Job Scheduler Task</h3>
                    <p>To begin, you need to navigate to the Job Scheduler section in the Liferay Control Panel:</p>
                    <ul>
                        <li>Open the Global Menu and go to <strong>Control Panel</strong>.</li>
                        <li>Navigate to <strong>Configuration → Job Scheduler</strong>.</li>
                        <li>Click the <strong>Add</strong> button and select a template for your task.</li>
                    </ul>
                    <p>The selected template will define the core logic of the job. You can customize the task by setting specific properties in the settings editor, which will be injected at runtime without requiring code changes or redeployment.</p>

                    <h3>2. Scheduling the Job</h3>
                    <p>Once you've created the Job Scheduler task, the next step is to schedule when it will run. To activate the trigger and define its schedule:</p>
                    <ul>
                        <li>Go to the <strong>Job Scheduler Triggers</strong> tab.</li>
                        <li>Click the desired task and go to the <strong>Job Scheduler Trigger</strong> tab.</li>
                        <li>Define the cron expression, start and end dates, time zone, and whether overlap is allowed.</li>
                        <li>Activate the trigger by saving the settings.</li>
                    </ul>

                    <h3>Code Example</h3>
                    <p>Create a taskExecuter class which extends BaseDispatchTaskExecutor class and define your task inside 'doExecute' method.</p>
                    <pre><code>
{`@Component(
    property = {
        "dispatch.task.executor.name=customtask", "dispatch.task.executor.type=customtask"
    },
    service = DispatchTaskExecutor.class
)
public class CustomTaskExecutor extends BaseDispatchTaskExecutor{

	@Override
	public String getName() {
		// TODO Auto-generated method stub
		return "customtask";
	}

	@Override
	public void doExecute(DispatchTrigger dispatchTrigger, DispatchTaskExecutorOutput dispatchTaskExecutorOutput)
			throws Exception {
		// TODO Auto-generated method stub
		System.out.println("Task is being Execute ...");		
	}
}`}
                    </code></pre>

                    <p>Deploy above module in Liferay and follow the below steps:</p>
                    <section>
                        <p><strong>Go to Control Panel -</strong> click on Job Scheduler.</p>
                        <p><strong>Create a New Scheduler -</strong> click on Add New.</p>
                        <p><strong>Select our task -</strong> in our case that would be 'customtask'.</p>
                        <img src="/images/blogs/schedularblog3.png" alt="liferay-scheduler-1" style={{ width: '100%', borderRadius: '20px' }} />
                        <hr />
                    </section>

                    <section>
                        <p><strong>Give a name -</strong> here we give name 'My Custom Task' and click on save.</p>
                        <p><strong>Open our task -</strong> as we save, reopen our task. Now you are able to see the tab for 'Job Scheduler Trigger'. Click on it.</p>
                        <img src="/images/blogs/schedularblog2.png" alt="liferay-scheduler-2" style={{ width: '100%', borderRadius: '20px' }} />
                        <hr />
                    </section>

                    <section>
                        <p><strong>Active the scheduler and Set The time -</strong> use cron expression for setting up time and you can also run the job manually.</p>
                        <img src="/images/blogs/schedularblog3.png" alt="liferay-scheduler-3" style={{ width: '100%', borderRadius: '20px' }} />
                        <hr />
                    </section>
                </section>

                <footer>
                    <h2>Conclusion</h2>
                    <p>The Liferay Job Scheduler is an essential tool for automating tasks and improving workflow efficiency. Whether you're managing data integration tasks, generating reports, or performing periodic maintenance, this tool allows you to schedule, monitor, and execute tasks with ease.</p>
                    <p>Happy coding! &#128521;</p>
                </footer>

            </article>
        </div>
    );
};
